module.exports = __webpack_public_path__ + "static/media/logo_ostellato.9bcfe863.webp";